import { useQueryString } from '#hooks/useQueryString';
import { useGetRecordsV2 } from '../api';
import { SERACH_QUERY } from './useDashboardChartFormProcess';

export const usePreviousChart = () => {
  const [previousRegisteredLectureId] = useQueryString([
    SERACH_QUERY.PREVIOUS_REGISTERED_LECTURE_ID
  ]);

  return useGetRecordsV2(previousRegisteredLectureId);
};
